import _CONST from '@/const/index'
import zhLocaleElement from 'element-plus/es/locale/lang/zh-cn'
import enLocaleElement from 'element-plus/es/locale/lang/en'
import esLocaleElement from 'element-plus/es/locale/lang/es'
import plLocaleElement from 'element-plus/es/locale/lang/pl'
import deLocaleElement from 'element-plus/es/locale/lang/de'
import frLocaleElement from 'element-plus/es/locale/lang/fr'
import koLocaleElement from 'element-plus/es/locale/lang/ko'
import nlLocaleElement from 'element-plus/es/locale/lang/nl'
import ptLocaleElement from 'element-plus/es/locale/lang/pt'
import itLocaleElement from 'element-plus/es/locale/lang/it'
import ukLocaleElement from 'element-plus/es/locale/lang/uk'
import svLocaleElement from 'element-plus/es/locale/lang/sv'
import viLocaleElement from 'element-plus/es/locale/lang/vi'
import thLocaleElement from 'element-plus/es/locale/lang/th'
import urLocaleElement from '@/lang/element_ur'
import arLocaleElement from 'element-plus/es/locale/lang/ar'
import trLocaleElement from 'element-plus/es/locale/lang/tr'
import csLocaleElement from 'element-plus/es/locale/lang/cs'
import bsLocaleElement from '@/lang/element_bs'
import ruLocaleElement from 'element-plus/es/locale/lang/ru'
import fiLocaleElement from 'element-plus/es/locale/lang/fi'
import roLocaleElement from 'element-plus/es/locale/lang/ro'
import nbLocaleElement from 'element-plus/es/locale/lang/nb-no'
import daLocaleElement from 'element-plus/es/locale/lang/da'
import ltLocaleElement from 'element-plus/es/locale/lang/lt'

import i18n, { loadLanguageAsync } from '@/lang' // 引入 i18n 实例
import router from '@/router'
import { mapOldToNew, mapNewToOld } from '@/router/routerToMap.js'
// 修改标签ico
export const updateIco = (url) => {
  let link = document.querySelector("link[rel*='icon']") || document.createElement('link');
  link.type = 'image/x-icon';
  link.rel = 'shortcut icon';
  link.href = url;
  document.getElementsByTagName('head')[0].appendChild(link);
}
// 修改主题色
export const updateTheme = (theme) => {
  console.log("行号: 38", theme)
  // const themeCluster = getThemeCluster(theme)
  // console.log("🚀 ~ updateTheme ~ themeCluster:", themeCluster)
  // 设置 Element Plus 的主要主题色 CSS 变量
  document.documentElement.style.setProperty('--el-color-primary', theme);
  document.documentElement.style.setProperty('--el-color-primary-light-3', getThemeColor(theme, 0.3));
  document.documentElement.style.setProperty('--el-color-primary-light-5', getThemeColor(theme, 0.5));
  document.documentElement.style.setProperty('--el-color-primary-light-7', getThemeColor(theme, 0.7));
  document.documentElement.style.setProperty('--el-color-primary-light-8', getThemeColor(theme, 0.8));
  document.documentElement.style.setProperty('--el-color-primary-light-9', getThemeColor(theme, 0.9));
  document.documentElement.style.setProperty('--el-color-primary-dark-2', getThemeColor(theme, 0.2, "dark"));
  // 设置项目主题色
  document.documentElement.style.setProperty('--theme-color', theme);
  document.documentElement.style.setProperty('--theme-color2', getThemeColor(theme, 0.1));
  document.documentElement.style.setProperty('--theme-color3', getThemeColor(theme, 0.2));
  document.documentElement.style.setProperty('--theme-color4', getThemeColor(theme, 0.3));
  document.documentElement.style.setProperty('--theme-color5', getThemeColor(theme, 0.4));
  document.documentElement.style.setProperty('--theme-color6', getThemeColor(theme, 0.5));
  document.documentElement.style.setProperty('--theme-color7', getThemeColor(theme, 0.6));
  document.documentElement.style.setProperty('--theme-color8', getThemeColor(theme, 0.7));
  document.documentElement.style.setProperty('--theme-color9', getThemeColor(theme, 0.8));
  document.documentElement.style.setProperty('--theme-color10', getThemeColor(theme, 0.9));

  localStorage.setItem('themeColor', theme)
}
function getThemeColor(color, tint, type = "light"){
  const theme = color.replace('#', '')
  let red = parseInt(theme.slice(0, 2), 16)
    let green = parseInt(theme.slice(2, 4), 16)
    let blue = parseInt(theme.slice(4, 6), 16)
    if(type === "light"){
      red += Math.round(tint * (255 - red))
      green += Math.round(tint * (255 - green))
      blue += Math.round(tint * (255 - blue))
    }else{
      red = Math.round((1 - tint) * red)
      green = Math.round((1 - tint) * green)
      blue = Math.round((1 - tint) * blue)
    }
    red = red.toString(16)
    green = green.toString(16)
    blue = blue.toString(16)
    return `#${red}${green}${blue}`
}
// 修改语言
export const  updateLang = async (language) => {
  console.log("🚀 ~ updateLang ~ language:", language)
  console.log("🚀 ~ updateLang ~ i18n.global.locale:", i18n.global, _CONST.languageOptions[language])
  console.log("🚀 ~ updateLang ~ i18n.global.locale:", i18n.global.locale)
  console.log("🚀 ~ updateLang ~ i18n.global.locale:", i18n.global.locale.value)
  await loadLanguageAsync(language);
  i18n.global.locale.value = _CONST.languageOptions[language]
  console.log("🚀 ~ updateLang ~ i18n.global.locale.value:", i18n.global.locale.value)
  localStorage.setItem('lang', language)
}
// 修改ui新旧版本
export const switchUiVersions = (value, childRoute) => {
  return new Promise((resolve, reject) => {
    window.history.replaceState({}, document.title, window.location.href);
    console.log("🚀 ~ switchUiVersions ~ value:", value, router)
    let path
    if(value){
      console.log("行号: 97", childRoute)
      path = mapOldToNew?.[childRoute?.path] || "/overview/plantStation"
    }else{
      path = mapNewToOld?.[router?.currentRoute?.value?.path] || "/station"
    }

    resolve()

    window.history.replaceState({}, document.title);
    router.replace({
      path,
    })
  })
}

// 截取url/#/之后的路径
function extractPath(str) {
  const parts = str.split('/#/');
  return parts[1] || '';
}

// ===========
export function getLang() {
  let language = localStorage.getItem('lang') || getSystemLanguage("number")
  return language
}
/**
 * @description: 获取系统语言
 * @return {*}
 */
export function getSystemLanguage(type = "number"){
  let localStorageLang = localStorage.getItem('lang')
  let lang = navigator.language || navigator.userLanguage // 获取浏览器语言
  lang = lang.substring(0, 2)
  if(type === "number"){
    if(localStorageLang){
      return localStorageLang
    }else{
      return _CONST.systemLanguageOptions[lang] || (import.meta.env.VITE_ACCESS_TYPE === "zh" ? '1' : '2')
    }
  }else if(type === "string"){
    if(localStorageLang){
      return _CONST.languageOptions[localStorageLang]
    }else{
      return lang || (import.meta.env.VITE_ACCESS_TYPE === "zh" ? "zh" : "en")
    }
  }else{
    console.error("语言获取错误")
  }
}

export function getLangStr() {
  return _CONST.languageOptions[localStorage.getItem('lang')] || getSystemLanguage("string")
}

export function getElementPlusLangJson(lang) {
  let langJson = {
    zh: zhLocaleElement,
    en: enLocaleElement,
    es: esLocaleElement,
    pl: plLocaleElement,
    de: deLocaleElement,
    fr: frLocaleElement,
    ko: koLocaleElement,
    nl: nlLocaleElement,
    pt: ptLocaleElement,
    it: itLocaleElement,
    uk: ukLocaleElement,
    sv: svLocaleElement,
    vi: viLocaleElement,
    th: thLocaleElement,
    ur: urLocaleElement,
    ar: arLocaleElement,
    tr: trLocaleElement,
    cs: csLocaleElement,
    bs: bsLocaleElement,
    ru: ruLocaleElement,
    fi: fiLocaleElement,
    ro: roLocaleElement,
    nb: nbLocaleElement,
    da: daLocaleElement,
    lt: ltLocaleElement,
  }
  const langStr = _CONST.languageOptions[lang]
  return langJson[langStr]
}
// 将1,2,3转成zh,en
export function transformLanguage(language) {
  const viteAccessType = import.meta.env.VITE_ACCESS_TYPE
  if(!language) return viteAccessType === 'en' ? 'en' : 'zh'
  const ret = _CONST.languageOptions[language]
  return Object.keys(_CONST.systemLanguageOptions).includes(ret) ? ret : 'en'
}
